export default {"src":"/_next/static/media/oldit.b8ba9885.svg","height":53,"width":53,"blurWidth":0,"blurHeight":0};